'use client';

import { forwardRef, HTMLAttributes } from 'react';
import styles from './Divider.module.css';

type DividerVariant = 'full' | 'inset' | 'middle';
type DividerOrientation = 'horizontal' | 'vertical';
type DividerTone = 'primary' | 'secondary';

export interface DividerProps extends HTMLAttributes<HTMLDivElement> {
  variant?: DividerVariant;
  orientation?: DividerOrientation;
  /** 'primary' (default) = Grey700 @ 90%; 'secondary' = Grey600 (stronger). */
  tone?: DividerTone;
  label?: string;
}

const Divider = forwardRef<HTMLDivElement, DividerProps>(({
  variant = 'full',
  orientation = 'horizontal',
  tone = 'primary',
  label,
  className = '',
  ...props
}, ref) => {
  const hasLabel = Boolean(label) && orientation === 'horizontal';

  return (
    <div
      ref={ref}
      className={[
        styles.divider,
        styles[variant],
        styles[orientation],
        tone === 'secondary' ? styles.secondary : '',
        hasLabel ? styles.withLabel : '',
        className,
      ].filter(Boolean).join(' ')}
      role="separator"
      aria-orientation={orientation}
      {...props}
    >
      {hasLabel && (
        <>
          <span className={styles.line} />
          <span className={styles.label}>{label}</span>
          <span className={styles.line} />
        </>
      )}
    </div>
  );
});

Divider.displayName = 'Divider';
export default Divider;
